export const HIDE_FEEDBACK_CARD_STORAGE_KEY =
  'hide_translate_and_adapt_feedback_card';
export const SHOW_FEEDBACK_CARD_STORAGE_KEY =
  'show_translate_and_adapt_feedback_card';

export const DISMISS_EXPIRES_AT_DAYS = 90;
export const FEEDBACK_EXPIRES_AT_DAYS = 180;
export const REVIEWED_EXPIRES_AT_YEARS = 10;
